import { render, staticRenderFns } from "./ListGiveaways.vue?vue&type=template&id=43e50f80&scoped=true"
import script from "./ListGiveaways.vue?vue&type=script&lang=js"
export * from "./ListGiveaways.vue?vue&type=script&lang=js"
import style0 from "./ListGiveaways.vue?vue&type=style&index=0&id=43e50f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e50f80",
  null
  
)

export default component.exports